import { render } from "./VlibrasComp.vue?vue&type=template&id=089723aa"
import script from "./VlibrasComp.vue?vue&type=script&lang=js"
export * from "./VlibrasComp.vue?vue&type=script&lang=js"

import "./VlibrasComp.vue?vue&type=style&index=0&id=089723aa&lang=css"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__